/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
*
* @export
* @enum {string}
*/
export var EnumZboTypPripadu;
(function (EnumZboTypPripadu) {
    EnumZboTypPripadu["ZUK"] = "ZUK";
    EnumZboTypPripadu["SAMSTAN"] = "SAMSTAN";
    EnumZboTypPripadu["SMLOUVA"] = "SMLOUVA";
    EnumZboTypPripadu["OPP"] = "OPP";
    EnumZboTypPripadu["MIPO"] = "MIPO";
    EnumZboTypPripadu["ZADOST_PP"] = "ZADOST_PP";
})(EnumZboTypPripadu || (EnumZboTypPripadu = {}));
//# sourceMappingURL=enum-zbo-typ-pripadu.js.map